import React from 'react';
import { Link as RRDLink, LinkProps } from 'react-router-dom';
import { notMyBusinessAnymore } from 'shared/consts';

interface Props extends LinkProps {
  to: string; // only const
}

export const Link: React.FC<Props> = (props) => {
  if (notMyBusinessAnymore.some((regexp) => regexp.test(props.to))) {
    const { to, ...rest } = props;
    return <a href={props.to} {...rest} />;
  }

  return <RRDLink {...props} />;
};
